import React from 'react';

import PlayExample from './PlayExample';
import Record from './Record';
import ListenRecording from './ListenRecording';
import RateSlider from './RateSlider';

const Controls = props => (
  <div className="pronounce-controls">
    <span className="pronounce-buttons">
      <span>
        <PlayExample config={props.config} deviceConfig={props.deviceConfig} voices={props.voices} togglePlayExample={props.togglePlayExample} text={props.text} mode={props.mode} isStopped={props.isStopped} isPlayingExample={props.isPlayingExample} rate={props.rate} setRate={props.setRate}/>
      </span>
      <span>
        <Record config={props.config} deviceConfig={props.deviceConfig} text={props.text} isStopped={props.isStopped} record={props.record} isRecording={props.isRecording} />
      </span>
      <span>
        <ListenRecording config={props.config} deviceConfig={props.deviceConfig}  text={props.text} isStopped={props.isStopped} isPlayingRecording={props.isPlayingRecording} toggleRecordPlayback={props.toggleRecordPlayback} downloadAudio={props.downloadAudio} />
      </span>
    </span>
  </div>

)

export default Controls;



// WEBPACK FOOTER //
// ./src/components/Controls.js